import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { ButtonGroupTab } from 'components/Ui/styled';
import { TutoringV2TabItem } from '../tutoringV2CommonUtils';
import BookNewSessionTabV2 from './BookNewSessionTabV2/BookNewSessionTabV2';
import SubjectAndTutorsTabV2 from './subjectAndTutorsTabV2/SubjectAndTutorsTabV2';
import ManageTimeBlocksTabV2 from './ManageTimeBlocksTabV2/ManageTimeBlocksTabV2';
import ViewBookedSessionsTabV2 from './ViewBookedSessionsTabV2/ViewBookedSessionsTabV2';
import { TabContent } from 'layouts/studentSuccessAdvocate/ssa/components/ssaCommonUtils';

function TutoringV2Tab() {
  const tabs = [
    {
      key: 'subjects & tutors',
      label: 'Subjects & Tutors',
      component: <SubjectAndTutorsTabV2 />,
    },
    {
      key: 'manage time blocks',
      label: 'Manage Time Blocks',
      component: <ManageTimeBlocksTabV2 />,
    },
    {
      key: 'view booked sessions',
      label: 'View Booked Sessions',
      component: <ViewBookedSessionsTabV2 />,
    },
    {
      key: 'book new session',
      label: 'Book New Session',
      component: <BookNewSessionTabV2 />,
    },
  ];

  const [selected, setSelected] = useState(tabs[0].key);

  return (
    <>
      <Box display="flex" justifyContent="left" mt={2} mb={1} ml={3}>
        <ButtonGroupTab disableElevation>
          {tabs.map((tab) => (
            <TutoringV2TabItem
              tab={tab}
              key={tab.key}
              onSelect={setSelected}
              isSelected={selected === tab.key}
            />
          ))}
        </ButtonGroupTab>
      </Box>
      <TabContent tabs={tabs} selected={selected} />
    </>
  );
}

export default TutoringV2Tab;
